import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dialog } from "@/components/ui/Dialog";
import { Button } from "@/components/ui/Button";
import { readStorageConsent, saveStorageConsent } from "@/lib/cookie-consent";
import { i18n } from "@/i18n";

export function CookieConsent() {
  const [open, setOpen] = useState(() => !readStorageConsent());
  const [preferences, setPreferences] = useState(() => readStorageConsent()?.preferences ?? false);
  useEffect(() => {
    const edit = () => {
      setPreferences(readStorageConsent()?.preferences ?? false);
      setOpen(true);
    };
    window.addEventListener("noa:open-cookies", edit);
    return () => window.removeEventListener("noa:open-cookies", edit);
  }, []);
  function choose(value: boolean) {
    saveStorageConsent(value);
    if (value) {
      try {
        localStorage.setItem("i18nextLng", i18n.resolvedLanguage ?? "fr");
      } catch {
        /* stockage indisponible */
      }
    }
    setPreferences(value);
    setOpen(false);
  }
  return (
    <Dialog
      open={open}
      onClose={() => choose(false)}
      title="Cookies et stockages locaux"
      size="lg"
      description="Vous gardez le choix. Refuser les préférences facultatives ne bloque pas l'accès au service."
      footer={
        <>
          <Button variant="secondary" onClick={() => choose(false)}>
            Tout refuser
          </Button>
          <Button variant="secondary" onClick={() => choose(true)}>
            Tout accepter
          </Button>
          <Button onClick={() => choose(preferences)}>Enregistrer mes choix</Button>
        </>
      }
    >
      <div lang="fr" className="space-y-4 text-sm leading-relaxed">
        <p>
          NOA utilise des stockages nécessaires à la connexion, à la sécurité et à la mémorisation
          de votre choix. Ils restent actifs. Aucun traceur publicitaire ni outil tiers de mesure
          d'audience n'est chargé par le site.
        </p>
        <label className="flex items-start gap-3 rounded-lg border border-line p-4">
          <input
            type="checkbox"
            checked={preferences}
            onChange={(e) => setPreferences(e.target.checked)}
            className="mt-1 size-5"
          />
          <span>
            <strong>Préférences facultatives</strong>
            <br />
            Mémoriser votre langue dans ce navigateur pour vos prochaines visites.
          </span>
        </label>
        <p>
          Votre choix est conservé six mois. Vous pouvez le modifier à tout moment avec « Gérer les
          cookies » en bas de page. Fermer cette fenêtre équivaut à refuser les préférences
          facultatives.
        </p>
        <Link
          to="/cookies"
          className="focus-ring text-brand underline"
          onClick={() => choose(false)}
        >
          Détail des stockages et de leurs durées
        </Link>
      </div>
    </Dialog>
  );
}

export function PrivacyControls() {
  return (
    <div lang="fr" className="flex flex-wrap gap-x-4 gap-y-2 text-xs">
      <Link to="/plan-du-site" className="focus-ring underline">
        Plan du site
      </Link>
      <Link to="/accessibilite" className="focus-ring underline">
        Accessibilité : non conforme
      </Link>
      <button
        type="button"
        className="focus-ring underline"
        onClick={() => window.dispatchEvent(new Event("noa:open-cookies"))}
      >
        Gérer les cookies
      </button>
    </div>
  );
}
